export default import.meta.ROLLDOWN_FILE_URL_sm5GT95GtpDa1ssPNjYDpA